import styled, { css } from 'styled-components';

export const style = css`
  display: inline-block;
  background-color: ${({ theme }) => theme.primaryColor};
  color: white;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 0.25rem 0.5rem;
`;

const Badge = styled.span`
  ${style}
`;

export default Badge;
